export type Message = {
  at: number;
  text: string;
};

export class Messages {
  private messages: Message[] = [];

  constructor(public retentionMs: number) {}

  public addMessage(text: string) {
    this.messages.push({
      at: Date.now(),
      text: text,
    });
  }

  public getMessages(now: number): Message[] {
    this.messages = this.messages.filter((msg) => {
      return now - msg.at < this.retentionMs;
    });

    return this.messages;
  }
}
